// Periodization used to live here under the "Annual Planner" name. It now lives in the
// athlete profile, so this keeps existing bookmarks and shared links working.
const AnnualPlannerRedirect = (app) => {
  app.get("/annual-planner", ({ req, res }) => {
    const { athlete, organizationCoach } = req.query;

    res.redirect(
      organizationCoach
        ? `/athlete-portal/profile?section=periodization&athlete=${athlete}&organizationCoach=${organizationCoach}`
        : `/athlete-portal/profile?section=periodization&athlete=${athlete}`
    );
  });
};

export default AnnualPlannerRedirect;
